import * as React from 'react';
import Svg, { SvgProps, Path } from 'react-native-svg';

const ThermometerIcon = (props: SvgProps) => (
  <Svg
    width={24}
    height={24}
    fill="none"
    {...props}
  >
    <Path
      stroke={props.color ?? '#3379BD'}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M6 6h2m-2 4h2m-2 4h1m5-.45V5a2 2 0 1 1 4 0v8.55a4 4 0 1 1-4 0Z"
    />
  </Svg>
);
export default ThermometerIcon;
